import React from 'react'
import { connect } from 'react-redux'
import { getSafe } from '../../../helpers/global';

class TransactionHistoryCellRender extends React.Component {
  render() {
    return this.renderContent()
  }

  renderTransactionType() {
    const { data, language } = this.props;
    const key = `transType_${data.type}`
    return (
      <div>
        <span>{language[key] ? language[key] : data.type}</span>
      </div>
    )
  }

  renderContent() {
    const { colDef } = this.props;
    switch (colDef.colId) {
      case 'common_transaction_type': return this.renderTransactionType();
      default: break;
    }
  }
}

export default connect(
  state => ({
    language: state.app.language
  })
)(TransactionHistoryCellRender)
